<template>
  <div>
    <h1 class="page-title">{{ $t('Contract.title') }}</h1>

    <div class="row">
      <div class="col">
        <span class="badge badge-pink badge-big">{{ contractState }}</span>
      </div>
      <div class="col">
        <div class="pull-right">
          <button type="button" class="btn" v-if="canSign" @click="applySignature">
            {{ $t('Contract.sign') }}
          </button>
          <a class="btn btn-icon" :href="pdfDownloadUrl">
            <i class="fa fa-download"></i>
          </a>
          <button type="button" class="btn btn-icon-dark ml-3" v-if="canBeDeleted" @click="deleteContract">
            <i class="fa fa-trash-o text-white"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <contract-steps :contract="contract" />
      </div>
    </div>
    <div class="pdf-container">
      <pdf-viewer :src="pdfUrl" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import pdfViewer from './pdfViewer';
import ContractSteps from './ContractSteps';

export default {
  name: 'Contract',
  components: { pdfViewer, ContractSteps },
  mounted() {
    this.getContract(this.contractId);
  },
  computed: {
    ...mapGetters({
      contract: 'contracts/contract'
    }),
    pdfUrl() {
      return this.contract.pdf_url;
    },
    pdfDownloadUrl() {
      return this.contract.pdf_download_url;
    },
    contractId() {
      return this.$route.params.id;
    },
    contractState() {
      return this.contract.state;
    },
    hasContract() {
      return null !== this.contract.id;
    },
    canSign() {
      return this.contract.can_sign && !this.contract.is_signed;
    },
    canBeDeleted() {
      return this.contract.can_be_deleted;
    }
  },
  methods: {
    ...mapActions({
      getContract: 'contracts/getContract',
      sign: 'contracts/sign',
      delete: 'contracts/delete'
    }),
    deleteContract() {
      this.$dialog.confirm(this.$i18n.t('Contract.deleteConfirm'))
        .then(async (dialog) => {
          await this.delete(this.contract);
          if (!this.hasContract) {
            this.$router.push({ name: 'Offers' });
          }
        });
    },
    applySignature() {
      this.$dialog.confirm(this.$i18n.t('Contract.signConfirm'))
        .then(dialog => {
          this.sign(this.contract);
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.pdf-container {
  padding: 0 1rem;
  max-width: 22cm;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/contracts/Contract.vue